export default function rightMenuBuyer(ctx) {
  return [
    {
      name: ctx.$gettext('My company'),
      type: 'router-link',
      classNames: 'header__subnav-link header__subnav-link--comp-info',
      action: ctx.$makeRoute({name: 'BuyerCompanyInfo'}),
      hasLogo: true,
      condition: ctx.userIsEnterpriseMember && !ctx.isEmailVerificationRequired
    },
    {
      name: ctx.$gettext('Tickets'),
      type: 'router-link',
      classNames: 'header__subnav-link header__subnav-link--tickets',
      action: ctx.$makeRoute({
        name: 'BuyerTicketSystem',
        query: {view: 'opened', page: 1}
      }),
      condition: !ctx.isEmailVerificationRequired
    },
    {
      name: ctx.$gettext('Change password'),
      type: 'router-link',
      classNames: 'header__subnav-link header__subnav-link--password',
      action: ctx.$makeRoute({name: 'BuyerChangePassword'}),
      condition: true
    },
    {
      name: ctx.$gettext('Notifications settings'),
      type: 'router-link',
      classNames: 'header__subnav-link header__subnav-link--settings',
      action: ctx.$makeRoute({name: 'BuyerPreferencesNotifications'}),
      condition: (ctx.userIsBusiness || ctx.userIsEnterpriseMember) && !ctx.isTranslationOnly
    },
    {
      name: ctx.$gettext('Accessibility'),
      type: 'button',
      classNames: 'header__subnav-link header__subnav-link--accessibility',
      action: 'openAccessibilityModal',
      condition: true
    },
    {
      name: ctx.$gettext('Video test'),
      type: 'router-link',
      classNames: 'header__subnav-link header__subnav-link--video-test',
      action: ctx.$makeRoute({name: 'BuyerTestVideo'}),
      condition: !ctx.isTranslationOnly
    },
    {
      name: '',
      type: 'subnav-lang-selector',
      classNames: '',
      condition: ctx.isMobileView
    },
    {
      name: ctx.$gettext('Help'),
      type: 'link',
      classNames: 'header__subnav-link header__subnav-link--help-link',
      href: 'https://support.salita.no/collection/380-tolkebruker',
      target: '_blank',
      condition: ctx.isMobileView
    },
    {
      name: ctx.$gettext('Sign out'),
      type: 'button',
      classNames: 'header__subnav-link header__subnav-link--sign-out',
      action: 'logOut',
      condition: true
    }
  ];
}
